import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslocoModule } from '@jsverse/transloco';
import { NotificationBellComponent } from '@rma/dashboard/notification-bell/public/orc-header-bell-icon';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { NavSubscriptionHeaderComponent } from '../orc-nav-subscription-header/nav-subscription-header.component';
import { HeaderLogoComponent } from '../ui-logo/header-logo.component';
import { TrialRemainingDaysComponent } from '../ui-trial-remaining-days/trial-remaining-days.component';
import { HeaderFacade } from './header.facade';

@Component({
  selector: 'rma-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.has-side-nav]': 'hasSideNav()',
    '(window:keydown.meta.k)': 'openSearchFromKeyboard($event)',
    '(window:keydown.control.k)': 'openSearchFromKeyboard($event)',
  },
  imports: [
    HeaderLogoComponent,
    MatButtonModule,
    MatToolbarModule,
    NavSubscriptionHeaderComponent,
    NotificationBellComponent,
    RmaIconComponent,
    TranslocoModule,
    TrialRemainingDaysComponent,
  ],
  providers: [HeaderFacade],
})
export class HeaderComponent {
  protected readonly facade = inject(HeaderFacade);

  public readonly displaySideNavButton = input<boolean | null>(null);
  public readonly hasSideNav = input<boolean | null>(null);
  public readonly trialDays = input(0);
  public readonly isSubscribed = input(false);

  public readonly menuButtonClicked = output<void>();

  public openSearchFromKeyboard(event: Event): void {
    event.preventDefault();
    this.facade.openSearchModal();
  }

  public menuClick(): void {
    this.menuButtonClicked.emit();
  }
}
